<h2 matDialogTitle>Upload Audio/Video</h2>
<mat-dialog-content>
    <admin-drop-media [isPublic]="isPublic" [mediaFiles]="mediaFiles"></admin-drop-media>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false">Cancel</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial (click)="onClose()">Add</button>
</mat-dialog-actions>